import { gatewayApi as api } from './gatewayApi';
import { Part } from './operationsApi';

export interface PartAttribute {
  Id?: number;
  PartId: number;
  Part?: Pick<Part, 'Number' | 'Description'> & { Id?: any };
  Name: string;
  Description?: string;
  Active: boolean;
  CreatedDate?: string;
  ModifiedDate?: string;
}

export interface PartAttributeListResponse {
  data: PartAttribute[];
  total: number;
}

export interface PartAttributeSearchParams {
  page?: number;
  pageSize?: number;
  search?: string;
  active?: boolean;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export const partAttributesApi = {
  getAll: (params?: PartAttributeSearchParams): Promise<PartAttributeListResponse> =>
    api.get('/partattributes', params),

  getById: (id: number): Promise<PartAttribute> =>
    api.get(`/partattributes/${id}`),

  create: (item: Omit<PartAttribute, 'Id'>): Promise<PartAttribute> =>
    api.post('/partattributes', item),

  update: (id: number, item: Partial<PartAttribute>): Promise<PartAttribute> =>
    api.put(`/partattributes/${id}`, item),

  delete: (id: number): Promise<{ success: boolean; message: string }> =>
    api.delete(`/partattributes/${id}`),

  search: (params: PartAttributeSearchParams): Promise<PartAttributeListResponse> =>
    api.post('/partattributes/search', params),

  bulkActivate: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.put('/partattributes/bulk-activate', { ids }),

  bulkDeactivate: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.put('/partattributes/bulk-deactivate', { ids }),

  bulkDelete: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.post('/partattributes/bulk-delete', { ids }),

  getStatistics: (): Promise<{ total: number; active: number; inactive: number }> =>
    api.get('/partattributes/statistics'),

  exportToCSV: (params?: PartAttributeSearchParams): Promise<Blob> =>
    api.getBlob('/partattributes/export', { params }),

  validation: {
    validate: (item: Partial<PartAttribute>): string[] => {
      const errors: string[] = [];
      if (!item.PartId && (item.PartId as any) !== 0) {
        errors.push('Part is required');
      }
      if (!item.Name || item.Name.trim().length === 0) {
        errors.push('Name is required');
      } else if (item.Name.trim().length < 2) {
        errors.push('Name must be at least 2 characters');
      } else if (item.Name.trim().length > 100) {
        errors.push('Name must be less than 100 characters');
      }
      if (item.Description && item.Description.length > 500) {
        errors.push('Description must be less than 500 characters');
      }
      if (item.Active === undefined || item.Active === null) {
        errors.push('Active status is required');
      }
      return errors;
    },
    validateBulk: (ids: number[]): string[] => {
      const errors: string[] = [];
      if (!ids || ids.length === 0) errors.push('Select at least one item');
      if (ids.length > 100) errors.push('Too many selected items');
      return errors;
    },
  },
};

export default partAttributesApi; 